module.exports = __webpack_public_path__ + "img/Paraguay.9b3f9e94.svg";